import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { User } from '../users';
import { WasteCode } from './wasteCodes';

export interface LoadNature {
    crudStatus: number;
    _id: string;
    designation: string;
    createdBy?: User;
    usageCount?: {
        total: number;
        dailyTrucksPlanned: number;
        dailyTrucksRides: number;
    };
    displayOrder?: number;
    defaultWasteCodeId?: WasteCode;
    updatedAt?: string;
    createdAt?: string;
}

interface LoadNaturesResponse {
    message: string;
    data: LoadNature[];
}

export interface GetLoadNaturesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllLoadNatures = async (queries?: GetLoadNaturesQueries): Promise<LoadNaturesResponse> => {
    try {
        const response: AxiosResponse<LoadNaturesResponse> = await apiClient.get('/load-natures', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateLoadNatureBody {
    designation?: string;
    crudStatus?: number;
    displayOrder?: number | null;
    defaultWasteCodeId?: string | null;
}

export interface LoadNatureResponse {
    message: string;
    data: LoadNature;
}

export const updateLoadNature = async (loadNatureId: string, data: UpdateLoadNatureBody): Promise<LoadNatureResponse> => {
    try {
        const response: AxiosResponse<LoadNatureResponse> = await apiClient.patch('/load-natures/' + loadNatureId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateLoadNatureBody {
    designation: string;
    crudStatus?: number;
    displayOrder?: number | null;
    defaultWasteCodeId?: string | null;
}

export const createLoadNature = async (data: CreateLoadNatureBody): Promise<LoadNatureResponse> => {
    try {
        const response: AxiosResponse<LoadNatureResponse> = await apiClient.post('/load-natures', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
